import { IconType } from '@aibees/shared/components';
import { UserRelation } from '@aibees/shared/definition';
import { SocketMessageType } from '@aibees/shared/socket';
import { ReactNode } from 'react';

export interface NotificationsProps {
  className?: string;
  actions?: ReactNode[];
}

export enum NotificationType {
  Download = 'Download',
  EXPORT = 'EXPORT',
  EXPORT_INTEGRATION_ = 'EXPORT_INTEGRATION',
  EXPORT_ENRICHMENT = 'EXPORT_ENRICHMENT',
  CRAWL = 'CRAWL',
  Account = 'Account',
  Subscription = 'Subscription',
  Update = 'Update',
  SaveRecords = 'SaveRecords',
  SaveSearch = 'SaveSearch',
  PriceAndPlan = 'PriceAndPlan',
  List = 'List',
  Label = 'Label',
  AssignOwner = 'AssignOwner',
  ContactDetails = 'ContactDetails',
  Profile = 'Profile',
  UserManagement = 'UserManagement',
  AiPersonality = 'AiPersonality',
  ProfileInsight = 'ProfileInsight',
  EnrichSaveRecord = 'EnrichSaveRecord',
  Integration = 'Integration',
  Enrich = 'Enrich',
  TableLayoutModifier = 'TableLayoutModifier',
  AddLabel = 'AddLabel',
  AddList = 'AddList',
  RemoveLabel = 'RemoveLabel',
  RemoveList = 'RemoveList',
  CSVTemplate = 'CSVTemplate',
}

export enum NotificationMessageGroup {
  EVENT = 'EVENT',
  UPDATE = 'UPDATE',
}

export enum NotificationStatus {
  ALL = 'SENT,DELIVERED,ARCHIVED',
  SENT = 'SENT',
  DELIVERED = 'DELIVERED',
  DELETED = 'DELETED',
  ARCHIVED = 'ARCHIVED',
  RESTORE = 'RESTORE',
}

export enum NotificationMessageChannel {
  NOTIFICATION = 'NOTIFICATION',
}

export enum NotificationMetadataStatus {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
}

export enum NotificationActionType {
  MARK_AS_READ = 'MARK_AS_READ',
  DELIVER_ALL = 'deliver-all',
  DELIVER = 'deliver',
  ARCHIVE = 'archive',
  RESTORE = 'restore',
  DELETE = 'DELETE',
}

export type Environment = 'development' | 'production';

export type NotificationGroup = 'PERSON' | 'COMPANY';

export type NotificationMetadata = {
  download?: string;
  id?: string;
  icon?: IconType;
  link?: string;
  name: string;
  group: NotificationGroup;
  status: NotificationMetadataStatus;
  type: NotificationType;
  metadata: string;
  // TODO move status and type integration into share
  'integration.response': any;
  'integration.id': string;
  'integration.type': string;
  'integration.typeAlias': string;
};

export type NotificationMessage = {
  id: string;
  requestId: string;
  body: string;
  channel: NotificationMessageChannel;
  group: NotificationMessageGroup;
  secret: boolean;
  metadata: NotificationMetadata;
  expireDate: string;
  created: string;
};

export interface NotificationItem {
  id: string;
  recipient: string;
  message: NotificationMessage;
  status: NotificationStatus;
  user: UserRelation;
}

export type NotificationCountResponse = {
  channel: NotificationMessageChannel;
  status: NotificationStatus;
  count: number;
  group: NotificationMessageGroup;
};

export type OnReceiveSocketNotificationEvent = (
  data: NotificationCountSocketMessage
) => void;

export type NotificationCountSocketMessage = {
  type: SocketMessageType.NOTIFICATION_COUNT;
  message: {
    channel: NotificationMessageChannel;
    count: number;
    created: number;
    group: NotificationMessageGroup;
    status: NotificationStatus;
  }[];
};
